<template>
    <!--begin::Card-->
    <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header py-3">
            <div class="card-title align-items-start flex-column">
                <h3 class="card-label font-weight-bolder text-dark">
                    Üyelik Bilgilerim
                </h3>
                <span class="text-muted font-weight-bold font-size-sm mt-1"
                    >Üyelik bilgilerinizi güncelleyin</span
                >
                
            </div>
            <div class="card-toolbar">
                <button
                    type="reset"
                    class="btn btn-success mr-2"
                    @click="goToPaymentPage()"
                    ref="kt_save_changes"
                    :disabled="disabled"
                >
                    Ödeme Yap
                </button>
                
            </div>
        </div>
        <!--end::Header-->
        <!--begin::Form-->
        <form class="form">
            <!--begin::Body-->
            <div class="card-body">
                <div class="row" v-if="currentUserPersonalInfo.membership_renews_at">
                    <div class="col-lg-6 col-xl-9">
                        <h5 class="font-weight-bold mb-6"><b-badge variant="warning">Üyelik Yenileme: {{ currentUserPersonalInfo.membership_renews_at }}</b-badge></h5>
                    </div>
                    
                </div>
               
                <div class="row">
                    <label class="col-xl-3"></label>
                    <div class="col-lg-9 col-xl-6">
                        <h5 class="font-weight-bold mb-6">İşlem Özeti</h5>
                    </div>
                </div>
                
                    <v-data-table
                        :headers="headers"
                        :items="currentUserPersonalInfo.user.transactions"
                        :items-per-page="-1"
                        hide-default-footer
                        class="elevation-1"
                        
                        >
                        <template v-slot:[`item.amount`]="{ item }">
                            <span>{{ parseFloat(item.amount).toFixed(2) }} TL</span>
                        </template>
                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td>{{ item.transaction_date | formatDate }}</td>
                                    <td>{{ item.type }}</td>
                                    <td>{{ item.description }}</td>
                                    <td>{{ parseFloat(item.amount).toFixed(2) }} TL</td>
                                </tr>
                                <!-- Total row -->
                                <tr>
                                    <td class="font-weight-bold"></td>
                                    <td class="font-weight-bold"></td>
                                    <td class="font-weight-bold"><h4>Toplam</h4></td>
                                    <td class="font-weight-bold"><h4>{{ totalAmount.toFixed(2) }} TL</h4></td>
                                </tr>
                            </tbody>
                        </template>
                        
                    </v-data-table>

    
            </div>
            <!--end::Body-->
        </form>
        <!--end::Form-->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_PERSONAL_INFO } from "@/core/services/store/profile.module";


import constants from '@/core/constants/index';
//import axios from 'axios';
export default {
    name: "MembershipInformation",
    data() {
        return {
            headers: [
                { text: "Tarih", align: "start", value: "transaction_date", sortable: false },    
                { text: "İşlem", align: "start", value: "key", sortable: false },
                { text: "Açıklama", align: "start", value: "description", sortable: false },
                { text: "Tutar", align: "start", value: "value", sortable: false },
               
            ], 
            
            default_photo: "media/users/blank.png",
            current_photo: null,
            regions: constants.REGIONS,
            blood_groups: constants.BLOOD_GROUPS,
            parameters: [], 
            disabled: false
        };
    },
    
    created() {
        this.getPersonalInfo();
    },
    mounted() {
        this.disabled = this.totalAmount >= 0;
    },
    watch: {
        totalAmount(newVal) {
            this.disabled = newVal >= 0;
        }
    },
    methods: {
        

        goToPaymentPage(){
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = process.env.VUE_APP_PAYMENT_URL;

            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = 'amount';
            hiddenField.value = Math.abs(this.totalAmount);

            const userId = document.createElement('input');
            userId.type = 'hidden';
            userId.name = 'user_id';
            userId.value = this.currentUserPersonalInfo.user.id;

            const email = document.createElement('input');
            email.type = 'hidden';
            email.name = 'email';
            email.value = this.currentUserPersonalInfo.user.email;


            form.appendChild(hiddenField);
            form.appendChild(userId);
            form.appendChild(email);

            document.body.appendChild(form);
            form.submit();
        },

        getPersonalInfo() {
            this.$store.dispatch(GET_PERSONAL_INFO)
        },

    },
    computed: {
        ...mapGetters(["currentUserPersonalInfo"]),
        photo() {
            return this.current_photo == null
                ? this.default_photo
                : this.current_photo;
        },
        totalAmount() {
            return this.currentUserPersonalInfo.user.transactions.reduce((total, item) => total + parseFloat(item.amount || 0), 0);
        }
    }
};
</script>
